require('./_row-fullwidth-container');
require('./_row-fullwidth');
require('./utils/restApi');


$(window).on('load', function() {
    var bodyHeight = $('body').outerHeight();
    if( bodyHeight <= screen.height){
        $('footer').css('margin-top',
        $(document).outerHeight() 
        - ( $('header').outerHeight() + $('main').outerHeight() ) 
        - $('footer').outerHeight()
        );
    }

    var hash = window.location.hash;
    hash && $('ul.nav a[href="' + hash + '"]').tab('show');

    $('.nav-tabs a').click(function (e) {
        $(this).tab('show');
        var scrollmem = $('body').scrollTop() || $('html').scrollTop();
        window.location.hash = this.hash;
        $('html,body').scrollTop(scrollmem);
    });

    // $('main').addClass('init');

    // $('.slick').slick({
    //     dots: false,
    //     arrows: true,
    //     prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="fal fa-chevron-left"></i></button>',
    //     nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="fal fa-chevron-right"></i></button>',
    // });
});

$(document).ready(function() {
    // $('.mxm-form select, .gform_wrapper select').select2({
    //     minimumResultsForSearch: Infinity
    // });


    jconfirm.defaults = {
        type: 'primary',
        draggable: false,
        closeIcon: true,
        closeIconClass: 'fal fa-times',
        columnClass: 'medium',
    };




});

// $(window).on('load resize', setMainPadding);

function setMainPadding() {
    // $('[data-mainPadding]').css('padding-top', $('header').height());
}

require('./_object-fit');
require('./_fancybox');
require('./_scroll');
require('./_angeboterstellen');